import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { ClientAddressEntity } from './client-address.entity';
import { JobEntity } from './job.entity';

/**
 * PD-17093 — a job-site ship-to on a job (one of the customer's addresses).
 * Removing it soft-removes the row; adding it again recovers the row, so the
 * pair stays unique.
 */
@Index('job_ship_to__job_address', ['fkJobId', 'fkClientAddressId'], {
	unique: true,
})
@Index('job_ship_to__fk_client_address__id', ['fkClientAddressId'], {})
@Entity('job_ship_to')
export class JobShipToEntity extends BaseEntity {
	@Column('int', { name: 'fk_job__id', unsigned: true })
	public fkJobId!: number;

	@Column('int', { name: 'fk_client_address__id', unsigned: true })
	public fkClientAddressId!: number;

	@ManyToOne(() => JobEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_job__id', referencedColumnName: 'id' }])
	public job!: JobEntity;

	@ManyToOne(() => ClientAddressEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client_address__id', referencedColumnName: 'id' }])
	public clientAddress!: ClientAddressEntity;
}
